import { ExecutionBarConfig } from '../../../types/mf-execution.types'
import { PrimaryButton } from '../PrimaryButton'
import { SecondaryButton } from '../SecondaryButton'

export const ButtonsList = ({ buttons }: { buttons: ExecutionBarConfig['buttons'] }) => {
  if (!buttons || buttons?.length === 0) {
    return null
  }

  return (
    <div className='flex gap-3 w-full'>
      {buttons.map((button, index) => (
        <div key={index} className={`${button.width ? `w-[${button.width}px]` : 'flex-1'}`}>
          {button.isPrimary ? (
            <PrimaryButton
              testLocator={button.testLocator}
              onClick={button.onClick}
              label={button.text || ''}
              isDisabled={button.isDisabled}
              isActive={button.isActive}
              primaryButtonClassName='!h-[56px]'
            />
          ) : (
            <SecondaryButton
              testLocator={button.testLocator}
              onClick={button.onClick}
              label={button.text}
              isDisabled={button.isDisabled}
              isActive={button.isActive}
              secondaryButtonClassName='!h-[56px]'
            >
              {button.icon ?? null}
            </SecondaryButton>
          )}
        </div>
      ))}
    </div>
  )
}

